import React, {useEffect, useState} from 'react'
import { ChartContainer, ContentContainer, Input, InputContainer, Label, RowForm, Animation, Bacteries, Licznik, AnimationButton, BakteriaContainer } from './BakterieElements'
import {Line} from "react-chartjs-2";
import {InputLimitAndEmptyValueHandling} from "../../scripts/InputHandling";
import bakteria from '../../image/bakteryja.svg'

const Bakterie = () => {
    const [inputs, setInputs] = useState({StartN: 5, NMax: 100000, Temp: 37, Time: 30, Generacion: 20, Temp_min: 7, Temp_max: 46, Temp_opt: 38, Lamb: 4});
    const [Time, setTime] = useState([]);
    const [Value, setValue] = useState([]);
    const [Bakteria, setBakteria] = useState([]);
    const [isRunning, setIsRunning] = useState(false);
    const [Sim, setSim] = useState({});
    const [Liczbabakt, setLiczbabakt] = useState(inputs.StartN);
    const [Timesim, setTimesim] = useState(0);
    const InputsLimit = [
        {
            InputName: "StartN",
            LimitMax: null,
            LimitMin: 5,
            default: 5
        },
        {
            InputName: "NMax",
            LimitMax: 10000000000,
            LimitMin: null,
            default: 100000
        },
        {
            InputName: "Temp",
            LimitMax: null,
            LimitMin: -273.15,
            default: 37
        },
        {
            InputName: "Time",
            LimitMax: null,
            LimitMin: 1,
            default: 30
        },
        {
            InputName: "Generacion",
            LimitMax: null,
            LimitMin: 1,
            default: 20
        },
        {
            InputName: "Temp_min",
            LimitMax: null,
            LimitMin: -273.15,
            default: 7
        },
        {
            InputName: "Temp_max",
            LimitMax: null,
            LimitMin: -273.15,
            default: 46
        },
        {
            InputName: "Temp_opt",
            LimitMax: null,
            LimitMin: -273.15,
            default: 38
        },
        {
            InputName: "Lamb",
            LimitMax: null,
            LimitMin: 0,
            default: 4
        }];

    const handleOutFocus = (e) => {
        const properValue = InputLimitAndEmptyValueHandling(InputsLimit, e)
        setInputs({...inputs, [e.target.name]: properValue});
        e.target.value = properValue;
    }

    const Rosso = (T, Tmin, Topt, Tmax, g = 20) => {
        if (T < Tmin) {
            return 0;
        }
        Tmax += 0.01;
        g = g / 60;
        const miOpt = Math.log(2) / g;
        let miMax = (miOpt * (T - Tmax) * ((T - Tmin) ** 2)) / ((Topt - Tmin) * ((Topt - Tmin) * (T - Topt) - (Topt - Tmax) * (Topt + Tmin - 2 * T)));
        if (miMax < 0) {
            miMax = 0;
        }
        return miMax;
    }

    const BaranRobert = (N0, Nmax = 10 ** 9, t, T, Tmin, Topt, Tmax, g, lambda) => {
        const miMax= Rosso(T,Tmin,Topt,Tmax,g);
        const h0 = miMax*lambda;
        const y0 = Math.log(N0);
        const yMax = Math.log(Nmax);
        const out = [{
            x: 0,
            y: N0,
            yLog: y0
        }];
        for (let i = 1;i<=t;i++){
            const lag = i + (1/miMax)*Math.log(Math.E**(-miMax*i)+Math.E**(-h0)-Math.E**(-miMax*t-h0));
            const yt = y0 + miMax * lag - Math.log(1+((Math.E**(miMax*lag)-1)/(Math.E**(yMax-y0))));
            const Nt = Math.round(Math.E**yt);
            out.push({
                x: i,
                y: Nt,
                yLog: yt
            })
        }
        return out;
    }

    const getRandomPosition = () => Math.floor(Math.random() * 80) + 10;

    const addBakteria = (licz) => {
        console.log(Sim[licz]);
        setLiczbabakt(Sim[licz]["y"]);
        setTimesim(Sim[licz]["x"]);
        if(Bakteria.length > 2000){
            toggleBakteria();
        }
        if(licz<=inputs.Time) {
            let y = licz<inputs.Lamb || Sim[licz-1]["y"]===Sim[licz]["y"] ? 0 : Sim[licz]["y"]/1000;
            console.log(y)
            for (let i = 0; i < Math.floor(y); i++) {
                //console.log(i);
                const newBakteria = {
                    id: Date.now() + i,
                    src: bakteria,
                    top: getRandomPosition(),
                    left: getRandomPosition(),
                };
                setBakteria(prev => [...prev, newBakteria]);
            }
        }else {
            toggleBakteria();
        }
    };

    const startBakteria = () => {
        for (let i = 0; i < inputs.StartN; i++) {
            //console.log(i);
            const newBakteria = {
                id: Date.now() + i,
                src: bakteria,
                top: getRandomPosition(),
                left: getRandomPosition(),
            };
            setBakteria(prev => [...prev, newBakteria]);
        }
    }

    useEffect(() => {
        let interval;
        if (isRunning) {
            setBakteria([]);
            setLiczbabakt(inputs.StartN);
            let i = 0
            startBakteria();
            interval = setInterval(() => {
                i++;
                addBakteria(i);
            }, inputs.Generacion*1000); // 20 sekund
        }
        return () => clearInterval(interval); // Czyszczenie interwału przy unmount lub zatrzymaniu
    }, [isRunning]);

    const toggleBakteria = () => {
        setIsRunning(!isRunning);
    };


    useEffect(() => {
        const sim = BaranRobert(inputs.StartN, inputs.NMax, inputs.Time, inputs.Temp, inputs.Temp_min, inputs.Temp_opt, inputs.Temp_max, inputs.Generacion, inputs.Lamb);
        setSim(sim)
        setTime(sim.map(s => s.x));
        setValue(sim.map(s => s.y));
    }, [inputs])

    let data = {
        labels: Array.from(Time, (value, index) => (value===0) ? "Punkt startowy" : value),  // Etykiety osi X
        datasets: [
            {
                label: 'y',  // Legenda
                data: Value,  // Dane osi Y
                borderColor: 'rgba(75, 192, 192, 1)',  // Kolor linii
                backgroundColor: 'rgba(75, 192, 192, 0.2)',  // Kolor tła
                tension: 0.1,  // Gładkość linii
            },
        ],
    };

    // Opcje wykresu (opcjonalne)
    const options = {
        responsive: true,  // Responsywność
        plugins: {
            legend: {
                display: false,  // Pozycja legendy
            },
        },
        scales: {
            x: {
                title: {
                    display: true,
                    text: "Time [h]",
                    align: 'end',
                    font: {
                        size: 16,
                        weight: 'bold',
                    },
                    padding: 0
                }
            }
        }
    };
    return (
        <>
            <ContentContainer>
                <InputContainer>
                    <RowForm>
                        <Label htmlFor="StartN-input">Wprowadź liczbę początkową osobników:</Label>
                        <Input id="StartN-input" name="StartN" type="number" defaultValue={inputs.StartN} onBlur={handleOutFocus} min="1"/>
                    </RowForm>
                    <RowForm>
                        <Label htmlFor="NMax-input">Wprowadź maksymalną liczbę osobników:</Label>
                        <Input id="NMax-input" name="NMax" type="number" defaultValue={inputs.NMax} onBlur={handleOutFocus} max="10000000000" min={inputs.StartN+5}/>
                    </RowForm>
                    <RowForm>
                        <Label htmlFor="Temp-input">Wprowadź temepraturę w środowisku:</Label>
                        <Input id="Temp-input" name="Temp" type="number" defaultValue={inputs.Temp} onBlur={handleOutFocus} max="100" step={0.1}/>
                    </RowForm>
                    <RowForm>
                        <Label htmlFor="Time-input">Wprowadź długość symulacji:</Label>
                        <Input id="Time-input" name="Time" type="number" defaultValue={inputs.Time} onBlur={handleOutFocus} min="1"/>
                    </RowForm>
                    <RowForm>
                        <Label htmlFor="Generacion-input">Ile zajmuje jeden cykl podziału (w minutach):</Label>
                        <Input id="Generacion-input" name="Generacion" type="number" defaultValue={inputs.Generacion} onBlur={handleOutFocus} min="1"/>
                    </RowForm>
                    <RowForm>
                        <Label htmlFor="Temp-min-input">Wprowadź temeraturę minimalną dla bakterii:</Label>
                        <Input id="Temp-min-input" name="Temp_min" type="number" defaultValue={inputs.Temp_min} onBlur={handleOutFocus} min="1"/>
                    </RowForm>
                    <RowForm>
                        <Label htmlFor="Temp-max-input">Wprowadź temeraturę maksymalną dla bakterii:</Label>
                        <Input id="Temp-max-input" name="Temp_max" type="number" defaultValue={inputs.Temp_max} onBlur={handleOutFocus} min="1"/>
                    </RowForm>
                    <RowForm>
                        <Label htmlFor="Temp-opt-input">Wprowadź temeraturę optymalną dla bakterii:</Label>
                        <Input id="Temp-opt-input" name="Temp_opt" type="number" defaultValue={inputs.Temp_opt} onBlur={handleOutFocus} min="1"/>
                    </RowForm>
                    <RowForm>
                        <Label htmlFor="Lamb-input">Czas potrzebny na adaptację w środowisku:</Label>
                        <Input id="Lamb-input" name="Lamb" type="number" defaultValue={inputs.Lamb} onBlur={handleOutFocus} min="1"/>
                    </RowForm>
                </InputContainer>
                <ChartContainer>
                    <Line data={data} options={options} />
                </ChartContainer>
            </ContentContainer>
            <Animation>
                <BakteriaContainer>
                    {Bakteria.map((photo, index) => (
                        <Bacteries
                            key={photo.id}
                            src={photo.src}
                            alt={`Bakteria ${index + 1}`}
                            top={photo.top}
                            left={photo.left}
                            className="visible"
                        />
                    ))}
                </BakteriaContainer>
                <AnimationButton onClick={toggleBakteria}>{isRunning? "Stop animacji": "Start animacji"}</AnimationButton>
                <Licznik>Liczba bakterii: {Liczbabakt}</Licznik>
                <Licznik>Czas symulacji: {Timesim===0 ? "Punkt startowy" : Timesim}</Licznik>
            </Animation>
        </>
    )
}

export default Bakterie
